import { cn } from "@core-ui/utils/cn";
import { IconButton } from "@ui-kit/Button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import { forwardRef } from "react";
import type { ExtractComponentGeneric } from "../../../lib/extractComponentGeneric";

export type FloatingIconButtonProps = ExtractComponentGeneric<typeof IconButton> & {
	tooltip?: string;
};

export const FloatingIconButton = forwardRef<HTMLButtonElement, FloatingIconButtonProps>((props, ref) => {
	const { className, tooltip, ...otherProps } = props;

	const button = (
		<IconButton
			className={cn("size-[30px] shrink-0 p-1 text-muted active:text-primary-fg", className)}
			ref={ref}
			size="xs"
			variant="ghost"
			{...otherProps}
		/>
	);

	if (!tooltip) {
		return button;
	}

	return (
		<Tooltip>
			<TooltipTrigger asChild>{button}</TooltipTrigger>
			<TooltipContent>{tooltip}</TooltipContent>
		</Tooltip>
	);
});
